import { ProgramTheme } from './../lib/types/types';
/**
 * TODO - preamble
 */
import {
    DocUploadResponse,
    ErrorResponse,
    NewVerificationRequest,
    StudentPersonalInfoResponse,
    TeacherPersonalInfoResponse,
    PendingResponse,
    StudentPersonalInfoViewModel,
    TeacherPersonalInfoViewModel,
    SuccessResponse,
    DocUploadViewModel,
    ActiveMilitaryPersonalInfoViewModel,
    ActiveMilitaryPersonalInfoResponse,
    InactiveMilitaryPersonalInfoResponse,
    InactiveMilitaryPersonalInfoViewModel,
    SeniorPersonalInfoResponse,
    SeniorPersonalInfoViewModel,
    MilitaryStatusResponse,
    SSOResponse,
    FirstResponderPersonalInfoResponse,
    FirstResponderPersonalInfoViewModel,
    EmploymentPersonalInfoResponse,
    EmploymentPersonalInfoViewModel,
} from '../lib/types/types';
import { employmentPInfoReqEmpty } from '../lib/types/empties';

// ===================== New Verification ====================
export const mockNewRequest: NewVerificationRequest = {
    programId: '5bbd127d9781852f68e14ddc',
};

// ===================== Student Personal Info ====================

export const mockStudentPersonalInfoResponse: StudentPersonalInfoResponse = {
    verificationId: '5a3bffd5e4b05f0b878a9762',
    currentStep: 'collectStudentPersonalInfo',
    segment: 'student',
    subSegment: null,
    submissionUrl: '',
    instantMatchAttempts: 0,
};

// Continue the verification process for a given verificationId
export const mockStudentPersonalInfoViewModel: StudentPersonalInfoViewModel = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    birthDate: '', // ISO-8601 'YYYY-MM-DD'
    organization: {
        id: 0,
        name: '',
    },
    countryChoice: undefined,
    localeChoice: undefined,
};

// ===================== Teacher Personal Info ====================

export const mockTeacherPersonalInfoResponse: TeacherPersonalInfoResponse = {
    verificationId: '5a3bffd5e4b05f0b878a9762',
    currentStep: 'collectTeacherPersonalInfo',
    segment: 'teacher',
    subSegment: null,
    submissionUrl: '',
    instantMatchAttempts: 0,
};

// Continue the verification process for a given verificationId
export const mockTeacherPersonalInfoViewModel: TeacherPersonalInfoViewModel = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    organization: {
        id: 0,
        name: '',
    },
    localeChoice: undefined,
    countryChoice: undefined,
};

// ===================== Senior Personal Info ====================

export const mockSeniorPersonalInfoResponse: SeniorPersonalInfoResponse = {
    verificationId: '5a3bffd5e4b05f0b878a9762',
    currentStep: 'collectSeniorPersonalInfo',
    segment: 'senior',
    subSegment: null,
    submissionUrl: '',
    instantMatchAttempts: 0,
};

// Continue the verification process for a given verificationId
export const mockSeniorPersonalInfoViewModel: SeniorPersonalInfoViewModel = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    birthDate: '',
    postalCode: '',
    localeChoice: undefined,
    countryChoice: undefined,
};

// ===================== Military Status ====================
export const mockMilitaryStatusResponse: MilitaryStatusResponse = {
    verificationId: '5a3bffd5e4b05f0b878a9762',
    currentStep: 'collectMilitaryStatus',
    segment: 'military',
    subSegment: null,
    submissionUrl: '',
    availableStatuses: ['ACTIVE_DUTY'],
};

// ===================== Active Military Personal Info ====================

export const mockActiveMilitaryPersonalInfoResponse: ActiveMilitaryPersonalInfoResponse = {
    verificationId: '5a3bffd5e4b05f0b878a9762',
    currentStep: 'collectActiveMilitaryPersonalInfo',
    segment: 'military',
    subSegment: 'activeDuty',
    submissionUrl: '',
    instantMatchAttempts: 0,
};

// Continue the verification process for a given verificationId
export const mockActiveMilitaryPersonalInfoViewModel: ActiveMilitaryPersonalInfoViewModel = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    birthDate: '', // ISO-8601 'YYYY-MM-DD'
    status: undefined,
    organization: {
        id: 0,
        name: '',
    },
    localeChoice: undefined,
    countryChoice: undefined,
};

// ===================== Inactive Military Personal Info ====================

export const mockInactiveMilitaryPersonalInfoResponse: InactiveMilitaryPersonalInfoResponse = {
    verificationId: '5a3bffd5e4b05f0b878a9762',
    currentStep: 'collectInactiveMilitaryPersonalInfo',
    segment: 'military',
    subSegment: 'veteran',
    submissionUrl: '',
    instantMatchAttempts: 0,
};

// Continue the verification process for a given verificationId
export const mockInactiveMilitaryPersonalInfoViewModel: InactiveMilitaryPersonalInfoViewModel = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    birthDate: '', // ISO-8601 'YYYY-MM-DD'
    status: undefined,
    dischargeDate: '', // ISO-8601 'YYYY-MM-DD'
    organization: {
        id: 0,
        name: '',
    },
    localeChoice: undefined,
    countryChoice: undefined,
};

// ===================== First Responder Personal Info ====================

export const mockFirstResponderPersonalInfoResponse: FirstResponderPersonalInfoResponse = {
    verificationId: '5a3bffd5e4b05f0b878a9762',
    currentStep: 'collectFirstResponderPersonalInfo',
    segment: 'firstResponder',
    subSegment: 'emt',
    submissionUrl: '',
    availableStatuses: ['FIREFIGHTER'],
    instantMatchAttempts: 0,
};

// Continue the verification process for a given verificationId
export const mockFirstResponderPersonalInfoViewModel: FirstResponderPersonalInfoViewModel = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    birthDate: '', // ISO-8601 'YYYY-MM-DD'
    status: undefined,
    organization: {
        id: 0,
        name: '',
    },
    localeChoice: undefined,
    countryChoice: undefined,
};

// ===================== Employment Personal Info ====================

export const mockEmploymentPersonalInfoResponse: EmploymentPersonalInfoResponse = {
    verificationId: '5a3bffd5e4b05f0b878a9762',
    currentStep: 'collectEmployeePersonalInfo',
    segment: 'employment',
    subSegment: null,
    submissionUrl: '',
    instantMatchAttempts: 0,
};

// Continue the verification process for a given verificationId
export const mockEmploymentPersonalInfoViewModel: EmploymentPersonalInfoViewModel = employmentPInfoReqEmpty;

// ======================= Step Doc Upload =====================

export const mockDocUploadVerificationResponse: DocUploadResponse = {
    verificationId: '5a3bffd5e4b05f0b878a9762',
    currentStep: 'docUpload',
    segment: 'student',
    subSegment: null,
    submissionUrl: '',
};

// Continue the verification process for a given verificationId
export const mockDocUploadViewModel: DocUploadViewModel = {
    file1: null,
    file2: null,
    localeChoice: undefined,
    countryChoice: undefined,
};


// ========================= "Step" Success =======================

export const mockSuccessResponse: SuccessResponse = {
    verificationId: '5a3bffd5e4b05f0b878a9762',
    currentStep: 'success',
    segment: 'student',
    subSegment: null,
    rewardCode: 'MY_REWARD_123',
};
// There is no request associated with this step

// ============================ "Step" Error ===========================

export const mockErrorResponse: ErrorResponse = {
    verificationId: '5a3bffd5e4b05f0b878a9762',
    currentStep: 'error',
    segment: 'student',
    subSegment: null,
    errorIds: ['internalServerError'],
};
// There is no request associated with this step


// ============================ "Step" Under Review ===========================

export const mockPendingResponse: PendingResponse = {
    verificationId: '5a3bffd5e4b05f0b878a9762',
    currentStep: 'pending',
    statusUrl: '',
    segment: 'student',
    subSegment: null,
};
// There is no request associated with this step


// ======================== "Step" Doc Review Limit Exceeded =======================

export const mockDocReviewLimitExceededResponse: ErrorResponse = {
    verificationId: '5a3bffd5e4b05f0b878a9762',
    currentStep: 'error',
    segment: 'student',
    subSegment: null,
    errorIds: ['docReviewLimitExceeded'],
};
// There is no request associated with this step


// ======================== "Step" SSO =======================

export const mockSSOResponse: SSOResponse = {
    verificationId: '5a3bffd5e4b05f0b878a9762',
    loginUrl: 'loginUrl',
    cancelUrl: 'cancelUrl',
    currentStep: 'sso',
    segment: 'student',
    subSegment: null,
};
// There is no request associated with this step

// ======================= Student Theme =======================
export const mockInternationalStudentTheme: ProgramTheme = {
    isTestMode: true,
    isSmsNotifierConfigured: false,
    intl: {
        locale: 'en-US',
        messages: {
            companyName: 'sheerid',
            step: {
                personalInfo: {
                    title: 'Unlock this Student-Only Offer',
                },
                docUpload: {
                    title: 'We need your ID & class schedule',
                    subtitle: 'Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.',
                },
                success: {
                    title: 'Success! You\'ve been verified',
                    subtitle: 'Here is your personal coupon code. It is unique to you and can only be used once.',
                    redirectUrl: null,
                    redirectButtonText: 'Use code now',
                },
            },
        },
    },
    customCss: '/* \r\n\r\n**********************\r\nATTENTION - This configuration is written by sheerid-web-apps, my.sheerid.com\r\n**********************\r\n\r\n */',
    logoUrl: null,
    openOrgSearchEnabled: false,
    config: {
        countries: ['US', 'CA', 'GB'],
        locales: ['en-US'],
        maxReviewTime: '20_MIN',
        estimatedReviewTime: 'A_FEW_MINUTES',
        marketConsent: {
            enabled: null,
            required: null,
            message: null,
        },
        customMetadata: {
            enabled: false,
            keys: [],
        },
        customFaqLink: null,
        orgSearchUrl: 'https://orgsearch-preview.sheerid.net/rest/organization/search?tags=TITLE4%2CHEI&country=US%2CCA%2CGB%2CJP%2CMX%2CFR%2CDE%2CZW&type=UNIVERSITY&name=',
        orgTypes: ['UNIVERSITY'],
        excludedOrganizationIds: [],
    },
};
